import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

import BuildCourageTop from "../../components/BuildCourage/BuildCourageTop";
import BuildCourageExterior from "../../components/BuildCourage/BuildCourageExterior";
import BuildCourageInterior from "../../components/BuildCourage/BuildCourageInterior";
import BuildCourageSummary from "../../components/BuildCourage/BuildCourageSummary";

import "./BuildCourage.css";

const BuildCourage = () => {
  const [selectedExterior, setSelectedExterior] = useState(null);
  const [selectedInterior, setSelectedInterior] = useState(null);
  const [selectedDrive, setSelectedDrive] = useState("2wd");

  const prices = {
    "2wd": 419900,
    "4wd": 449900,
  };

  return (
    <div className="bcnaved">
      <Navbar />

      <div className="build-page-wrapper">

        {/* LEFT COLUMN */}
        <div className="build-left-col">

          <BuildCourageTop
            selectedDrive={selectedDrive}
            setSelectedDrive={setSelectedDrive}
          />

          <BuildCourageExterior
            onExteriorChange={(opt) => setSelectedExterior(opt)}
          />

          <BuildCourageInterior
            onInteriorChange={(opt) => setSelectedInterior(opt)}
          />
        </div>

        {/* RIGHT COLUMN — STICKY SUMMARY */}
        <div className="build-right-col">
          <BuildCourageSummary
            selectedDrive={selectedDrive}
            selectedExterior={selectedExterior}
            selectedInterior={selectedInterior}
            prices={prices}
          />
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default BuildCourage;
